// eslint-disable-next-line no-unused-vars
export const pristineState = i18n => ( {
	team: { id: "", type: "", members: [], },
	activePanel: "individuals",
	isWorkStyleDialogVisible: false,
} );
